module.exports = __webpack_public_path__ + "static/media/homepage-section-7.fbc95831.png";